import { View } from 'backbone';

import BaseControlView from 'BaseControlView.js';
import template from 'common-visuals/control-group.ejs';
import constants from 'Constants.js';
import Immutable  from 'immutable';
import eventBus         from 'EventBus.js';
import listService      from 'ListService.js';
import restService from 'RestService.js';
import util             from 'util/Util.js';
import configService from 'ConfigService';
import themeService from 'ThemeService.js';

import mobileListService from '../../service/mobile/MobileListService';


//=====================================================================
//
// An instance of this view represents a Group control
//
// Brad Trebilcock, January 2016
//
//=====================================================================
class GroupControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_ADVANCED_INPUTS;

        this.events = {
        };

        this.listenTo( eventBus, 'GroupThemeChange', function() {
            if (!listService.selected.size || (listService.selected.find(s => s.model.get('id') === this.model.get('id')))) {
                this.themeChangeRender();
            }
        });

        this.listenTo( eventBus, 'GroupPropertyChange', function() {
            if (!listService.selected.size || (listService.selected.find(s => s.model.get('id') === this.model.get('id')))) {
                this.render();
            }
        });

        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
  
        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });

        return this;
    }

    // Neighbor aligner uses this polymorphic property
    get kind() {
        this.model.get('showGroupHeader');
        return 'GroupControlView';
    }

    adjustPictureSettings() {
        let assetId = this.model.get('backgroundImageAssetId');
        let styleTag = '';
        if (typeof assetId !== 'undefined' && assetId !== '') {
            if (assetId === '~groupBgImage' && themeService.resolve('~groupBgImage') !== 'null') {
                assetId = themeService.resolve('~groupBgImage');
            }

            let bstylePictureAlign = this.model.get('backgroundImageStyle');
            const imgUrl = (!util.isEmpty(assetId) && assetId !== 'None' && assetId.indexOf('~') === -1) ? restService.getAssetURL(assetId) : '';
            if (typeof bstylePictureAlign === 'undefined' || bstylePictureAlign === '') {
                bstylePictureAlign = 'center'; //default value
                this.model.set('backgroundImageStyle', 'center', constants.MODEL_SILENT);
            }
            switch (bstylePictureAlign) {
                case 'center':
                    styleTag = imgUrl ? "background-image: url('" + imgUrl + "'); background-repeat: no-repeat; background-position: center;" : '';
                    break;
                case 'stretch':
                    styleTag =  imgUrl ? "background-size: 100% 100%; background-image: url('" + imgUrl + "'); background-repeat: no-repeat;": '';
                    break;
                case 'tile':
                    styleTag =  imgUrl ? "background-image: url('" + imgUrl + "'); background-repeat: repeat;": '';
                    break;
            }
        }
        
        this.model.set('pictureStyle', styleTag, constants.MODEL_SILENT);
    }

    afterRenderingGroups(renderOptions) {
        try {

            if (listService.isResizing) {
                return;
            }

            let minWidth = 1;
            let minHeight = 1;
             this.model.get('childList').forEach(v => {

                let vw = null;
                const id = v.id || v.get('id');

                if (listService.mainKind === constants.KIND_MOBILE) {
                    vw = mobileListService.getMobileControl(id);
                } else{
                    vw = listService.getObject(id);
                }

                if (vw) {
                    vw.render(renderOptions);

                    const left = v.left || v.get('left');
                    const top = v.top || v.get('top');
                    const width = v.width || v.get('width');
                    const height = v.height || v.get('height');

                    let currentWidth = Number( util.extractNum(left) )+Number( util.extractNum(width) );
                    let currentHeight = Number( util.extractNum(top) )+Number( util.extractNum(height) );
                    minWidth = Math.max(currentWidth, minWidth);
                    minHeight = Math.max(currentHeight, minHeight);

                    if (vw.model.get('factoryKey') !== 'control_timer'){
                        // Make the group a DOM parent of the kid
                        $(constants.ID_SEL + id).appendTo(`${constants.ID_SEL}${'groupItems' + this.id}`);
                    }
                } 
            });

            //PF-2324: Setting minimum width and height of groups
            this.model.set('minWidth', minWidth, constants.MODEL_SILENT);
            this.model.set('minHeight', minHeight, constants.MODEL_SILENT);
        } catch (e) {
            console.log(e);
        }
    }

}

export default GroupControlView;
